// extracted by mini-css-extract-plugin
module.exports = {"Checkout":"Cart_Checkout__29J6Q","Clear":"Cart_Clear__1igz9"};